import { formatAmount } from "src/utils/format-us-currency";
import { TCart, TPass } from "src/shared/types/globalStotre.types";
import { TTeamConfig } from "src/shared/types/teamConfig.types";

export function getPassCardPrice(pass: TPass, teamConfig: TTeamConfig) {
  let price = teamConfig?.LANDING_PAGE_SETTINGS?.PASS?.ADD_SERVICE_FEE_TO_PRICE
    ? pass.price + pass.serviceFee
    : pass.price;

  if (teamConfig?.TEAM_GLOBAL_SETTINGS?.PASS_PRICE_OVERRIDES) {
    const passPriceOverride =
      teamConfig?.TEAM_GLOBAL_SETTINGS?.PASS_PRICE_OVERRIDES.find(
        (override) => override.PASS_ID === pass.passId
      );

    if (passPriceOverride) price = passPriceOverride.PRICE;
  }

  const hideDecimals =
    teamConfig?.LANDING_PAGE_SETTINGS?.PASS?.HIDE_DECIMAL_POINTS_AFTER_PRICE;

  // grouped so prices over 999 render as "2,499" instead of "2499"
  return formatAmount(price, hideDecimals ? undefined : 2);
}

export function findHeldLocationsFromCart(cart: TCart) {
  const passLocations =
    cart?.passes
      ?.map((itm) => itm?.location)
      ?.filter((location) => !!location) || [];
  const addOnLocations =
    cart?.products
      ?.map((itm) => itm?.location)
      ?.filter((location) => !!location) || [];
  const reservationLocations =
    cart?.reservations
      ?.map((itm) => itm?.location)
      ?.filter((location) => !!location) || [];
  return [...passLocations, ...addOnLocations, ...reservationLocations];
}
